module.exports = __webpack_public_path__ + "static/media/Gittron__Avatar.4bb80cc7.png";